module.exports = __webpack_public_path__ + "img/BE_Mockups@2x.f3b6cd55.png";